/**
 * @deprecated Use typography.styles.ts instead
 * This file will be removed in a future version once all MUI components are migrated to Base UI.
 */
import type { TypographyVariantsOptions } from '@mui/material'

export const dsVariants = [
  'body1',
  'body2',
  'body3',
  'body3/cap',
  'body4',
  'body4/cap',
  'subtitle1',
  'subtitle2',
  'subtitle3',
  'overline',
  'caption',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
] as const

export const variants = [
  // Design System variants
  ...dsVariants,

  // Additional variants not in DS
  // TODO: remove them and cleanup from using them
  // TODO: make cleanup in /src/theme/overrides.d.ts
  'badge',
  'badge/label',
  'tooltip/label',
] as const

const INTER_FF = 'Inter, sans-serif'
const POPPINS_FF = 'Poppins, sans-serif'

export const typographyVariants: TypographyVariantsOptions = {
  body1: {
    fontSize: '16px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    fontWeight: 400,
  },
  body2: {
    fontSize: '14px',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    fontWeight: 500,
  },
  body3: {
    fontSize: '12px',
    lineHeight: '143%',
    letterSpacing: '0.15px',
    fontWeight: 500,
  },
  'body3/cap': {
    fontSize: '12px',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  body4: {
    fontSize: '10px',
    lineHeight: '143%',
    letterSpacing: '0.17px',
    fontWeight: 500,
  },
  'body4/cap': {
    fontSize: '10px',
    lineHeight: '120%',
    letterSpacing: '0.17px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
  subtitle1: {
    fontSize: '16px',
    lineHeight: '120%',
    letterSpacing: '0.15px',
    fontWeight: 600,
  },
  subtitle2: {
    fontSize: '14px',
    lineHeight: '140%',
    letterSpacing: '0.1px',
    fontWeight: 600,
  },
  subtitle3: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '157%',
    letterSpacing: '0.1px',
  },
  overline: {
    fontSize: '12px',
    lineHeight: '120%',
    letterSpacing: '1px',
    fontWeight: 400,
  },
  caption: {
    fontSize: '12px',
    lineHeight: '166%',
    letterSpacing: '0.4px',
    fontWeight: 400,
  },
  h1: {
    fontFamily: POPPINS_FF,
    fontSize: '72px',
    lineHeight: '116.7%',
    letterSpacing: '-1.5px',
    fontWeight: 600,
  },
  h2: {
    fontFamily: POPPINS_FF,
    fontSize: '48px',
    lineHeight: '120%',
    letterSpacing: '-0.5px',
    fontWeight: 600,
  },
  h3: {
    fontFamily: POPPINS_FF,
    fontSize: '40px',
    lineHeight: '116.7%',
    fontWeight: 600,
  },
  h4: {
    fontFamily: POPPINS_FF,
    fontSize: '32px',
    lineHeight: '123.5%',
    letterSpacing: '0.25px',
    fontWeight: 600,
  },
  h5: {
    fontFamily: POPPINS_FF,
    fontSize: '24px',
    lineHeight: '120%',
    fontWeight: 600,
  },
  h6: {
    fontFamily: POPPINS_FF,
    fontSize: '20px',
    lineHeight: '140%',
    letterSpacing: '0.15px',
    fontWeight: 600,
  },
  badge: {
    fontSize: '8px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '250%',
    letterSpacing: '0.14px',
    textTransform: 'uppercase',
  },
  'badge/label': {
    fontSize: '8px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '120%',
    letterSpacing: '0.14px',
    textTransform: 'uppercase',
  },
  'input/label': {
    fontSize: '12px',
    lineHeight: '100%',
    letterSpacing: '0.15px',
    fontWeight: 400,
  },
  'input/value': {
    fontSize: '14px',
    lineHeight: '128.571%',
    letterSpacing: '0.1px',
    fontWeight: 500,
  },
  'input/helper': {
    fontSize: '10px',
    lineHeight: '166%',
    letterSpacing: '0px',
    fontWeight: 400,
  },
  'tooltip/label': {
    fontSize: '12px',
    lineHeight: '120%',
    fontWeight: 400,
  },
}

export const themeTypography: TypographyVariantsOptions = {
  fontFamily: INTER_FF,
  ...typographyVariants,
}
